import React from 'react';
import Icon from '@ant-design/icons';

const ShelfSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48" strokeWidth="1">
        <path d="M42.03,4.55H6.04c-.69,0-1.25.56-1.25,1.25v35.99c0,.69.56,1.25,1.25,1.25h35.99c.69,0,1.25-.56,1.25-1.25V5.8c0-.69-.56-1.25-1.25-1.25ZM7.29,19.1h33.49v9.56H7.29v-9.56ZM40.78,7.05v9.55H7.29V7.05h33.49ZM7.29,40.54v-9.38h33.49v9.38H7.29Z"/>
        <path d="M20.97,11.43h6.14c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25h-6.14c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25Z"/>
        <path d="M27.1,20.89h-6.14c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h6.14c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25Z"/>
        <path d="M27.1,33.15h-6.14c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h6.14c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25Z"/>
    </svg>
);

const ShelfIcon = () => {
    return <Icon component={ShelfSvg} />;
};

export default ShelfIcon;
